import { render } from "./GenerativeFaq.vue?vue&type=template&id=009d3f4d&scoped=true&lang=pug"
import script from "./GenerativeFaq.vue?vue&type=script&lang=js"
export * from "./GenerativeFaq.vue?vue&type=script&lang=js"

import "./GenerativeFaq.vue?vue&type=style&index=0&id=009d3f4d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009d3f4d"]])

export default __exports__